import { render, staticRenderFns } from "./RequeteAPI.vue?vue&type=template&id=72ad625e&"
import script from "./RequeteAPI.vue?vue&type=script&lang=js&"
export * from "./RequeteAPI.vue?vue&type=script&lang=js&"
import style0 from "./RequeteAPI.vue?vue&type=style&index=0&id=72ad625e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports